import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import { ErrorProps } from 'services/error/types';
import { selectHarvestEventErrorsExist } from 'services/harvestEvents/selectors';

interface OwnProps extends ErrorProps {
    children: React.ReactElement;
}

interface ConnectedProps {
    errorsExist: ReturnType<typeof selectHarvestEventErrorsExist>;
}

type Props = OwnProps & ConnectedProps;

export class HarvestEventErrorsExistGateComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement | null {
        const { errorsExist, children } = this.props;
        if (!errorsExist) {
            return null;
        }
        return children;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    errorsExist: selectHarvestEventErrorsExist
});

export default connect(mapStateToProps)(HarvestEventErrorsExistGateComponent);
